import axios, {originalAxios} from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import { EnvironmentalResponseDTO, EnvironmentalDTO } from "./types";

const MS_URL = "/senana/api/farms/analysis";

export const create = async (analysisUuid : string, years: number[]): Promise<ResponseContent<EnvironmentalResponseDTO[]>> => 
  axios
  .post(`${MS_URL}/${analysisUuid}/environmental`, { years })
  .then(responseContent(EnvironmentalResponseDTO));

 export const find = async (analysisUuid: string, year: number): Promise<ResponseContent<EnvironmentalDTO>> => axios
  .get(`${MS_URL}/${analysisUuid}/environmental/${year}`,)
  .then(responseContent(EnvironmentalDTO))

export const downloadGeoJson = (url: string): Promise<GeoJSON.FeatureCollection> => originalAxios
  .get(url)
  .then(it => it.data);

export const downloadImage = (url: string) => originalAxios
  .get(url)
  .then(it => it.data);